<script>
import Vue from 'vue';
import {mapState, mapActions, mapGetters} from 'vuex';

export default Vue.extend({
    computed: {
        ...mapState({
            items: state => state.contract.overview.items,
            form: state => state.contract.contractManagement.form
        }),
        ...mapGetters({
            contractManagementPageForward: 'contract/contractManagementPageForward',
            contractManagementPageBackward: 'contract/contractManagementPageBackward',
            formHasChanged: 'contract/formHasChanged',
        })
    },
    methods: {
        ...mapActions({
            contractManagementFormPageSet: 'contract/contractManagementFormPageSet',
            contractManagementFormSave: 'contract/contractManagementFormSave'
        })
    }
});
</script>
<template>
    <div class="contract-management-edit-control">
        <div class="contract-management-edit-control__content">
            <div class="contract-management-edit-control__paging-buttons">
                <button :disabled="!contractManagementPageBackward"
                        class="contract-management-edit-control__page-btn"
                        @click="contractManagementFormPageSet(contractManagementPageBackward)">
                    <i class="fa fa-chevron-left"/>
                </button>
                <button :disabled="!contractManagementPageForward"
                        class="contract-management-edit-control__page-btn"
                        @click="contractManagementFormPageSet(contractManagementPageForward)">
                    <i class="fa fa-chevron-right"/>
                </button>
            </div>
            <div class="contract-management-edit-control__buttons">
                <button class="contract-management-edit-control__btn" @click="contractManagementFormSave()">
                    {{ $t('contractManagement.edit.form.save') }}
                </button>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractManagementEditControl/ContractManagementEditControl.vue